module.exports = {"TXTWCL_Responsible_gaming":{"id":"TXTWCL_Responsible_gaming","defaultMessage":"責任と分別あるゲーミング","track":"Responsible gaming"}}